module.exports = __webpack_public_path__ + "static/media/fibra-vidrio.85bedce4.png";